<div class="save-query-dialog">
  <form nz-form [formGroup]="saveQueryForm" (ngSubmit)="onSave()">
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired nzFor="queryName">Query Name</nz-form-label>
      <nz-form-control [nzSpan]="24" [nzValidateStatus]="saveQueryForm.get('queryName')!" [nzErrorTip]="saveQueryForm.get('queryName')?.hasError('required') ? 'Please enter Query Name' : saveQueryForm.get('queryName')?.hasError('pattern') ? 'Only alphnumric are allowed'  : saveQueryForm.get('queryName')?.hasError('minlength') ? 'Minimum 3 characters required': saveQueryForm.get('queryName')?.hasError('maxlength') ? 'Maximum 100 characters allowed' : ''">
        <input
          nz-input
          formControlName="queryName"
          id="queryName"
          placeholder="Enter a unique name for your query"
          autocomplete="off"
          maxlength="100"
        />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control [nzSpan]="24">
        <label nz-checkbox formControlName="isDefault">
          Set as default query
        </label>
      </nz-form-control>
    </nz-form-item>

    <div class="dialog-footer">
      <button nz-button nzType="default" type="button" (click)="onCancel()" [disabled]="loading">
        Cancel
      </button>
      <button nz-button nzType="primary" type="submit" [nzLoading]="loading">
        Save Query
      </button>
    </div>
  </form>
</div>
